import React, { useState } from 'react';
import { Container, VideoComponent, ClickCover, CoverWrapper } from './cardVideo.styles';
import { useBreakpointsContext } from '../../store/BreakpointsContext';
import { Modal } from '../modal';

export const CardVideo = ( {youtubeObj, imageCover} ) => {

  const [isOpen, setOpen] = useState(false);

  const { isDesktop } = useBreakpointsContext();

  const handleRequestClose = () => setOpen(false);

  const renderVideo = (youtubeObj) => (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      styles={{
        content: {
          height: 'auto',
          width: isDesktop ? '80%' : '100%',
          padding: isDesktop ? '25px' : '0',
        },
      }}
    >
      <VideoComponent dangerouslySetInnerHTML={{ __html: youtubeObj.html }} />
    </Modal>
  );


  const renderClickCover = (imageCover) => (
    <CoverWrapper>
      <ClickCover src={imageCover.value.image} onClick={() => setOpen(true)} />
    </CoverWrapper>
  );


  return (
    <Container>
      {renderVideo(youtubeObj)}
      {renderClickCover(imageCover)}
    </Container>
  )
};
